import React, {useEffect} from 'react';
import Modal, { ModalContentContainer } from '@components/Modal';
import { COUNTRIES_LIST } from '@helper/constants/international'; // adjust path as needed
import HookFormGroupCheckbox from './HookFormGroupCheckbox';
import { Button, FormGroupCheckbox } from 'nsw-ds-react';
import { useForm } from 'react-hook-form';
import { useInternationalAccessStore } from '@store/admin/international-access';



const CountriesUpdateModal = ({ defaultCountries, page, id, visible, onClose }) => {
	const store = useInternationalAccessStore((s) => s);
	console.log(defaultCountries);
	const defaultForm = {
		modalCountries: defaultCountries
	};
	const hookForm = useForm({
			defaultValues: defaultForm,
		});
	const { handleSubmit, reset } = hookForm;

	useEffect(() => {
    if (visible) {
      reset({
        modalCountries: defaultCountries,
      });
    }
  }, [defaultCountries, visible, reset]);

	const submitUpdate = (params) => {
    store.updateInternationalAccess(page, id, params.modalCountries)
		onClose()
  };

  return (
    <Modal isOpen={visible} onClick={onClose}>
      <ModalContentContainer onClick={e => e.stopPropagation()}>
			<form onSubmit={handleSubmit(submitUpdate)}>
				<HookFormGroupCheckbox
					hookForm={hookForm}
					name="modalCountries"
					label="Allowed Countries"
					options={COUNTRIES_LIST}
				/>

				<div className="tw-flex tw-justify-end tw-gap-2 tw-mt-4">
					<Button as="secondary" onClick={onClose}>Close</Button>
					<Button type="submit">Update</Button>
				</div>
			</form>
       </ModalContentContainer>
     </Modal>
  );
};

export default CountriesUpdateModal;
